var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinned = function SvgPinned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.124 6.892-1.36.785 6.731 11.66 1.36-.786-6.73-11.66Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.559 19.607a.785.785 0 1 0-.785-1.36.785.785 0 0 0 .785 1.36Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.467 12.52a5.61 5.61 0 1 0-5.609-9.715 5.61 5.61 0 0 0 5.61 9.716Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.663 6.259c1.084 0 1.963-.503 1.963-1.122 0-.62-.879-1.122-1.963-1.122-1.085 0-1.964.502-1.964 1.122 0 .62.88 1.122 1.964 1.122Z",
    fill: "#fff"
  })));
};
export default SvgPinned;